module.exports = __webpack_public_path__ + "img/ipay.6100bd45.png";